import axios from "axios";
import { Promise } from "q";
import { API_URL, STATUS_OK } from "./../../config";

const CancelToken = axios.CancelToken;
var lastURequest = CancelToken.source();
var lastERequest = CancelToken.source();

export default class SignupService {
    static signup = (name, lastName, username, email, password) => {
        return new Promise((resolve, reject) => {
            axios
                .post(API_URL + "users", {
                    name,
                    last_name: lastName,
                    username,
                    email,
                    password
                })
                .then(response => {
                    if (response.status === STATUS_OK) resolve(response.data);
                    else reject(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    };

    static usernameExists = username => {
        lastURequest.cancel();
        let newURequest = CancelToken.source();
        lastURequest = newURequest;
        return new Promise((resolve, reject) => {
            axios
                .get(API_URL + `usernames/${username}`, {
                    cancelToken: newURequest.token
                })
                .then(response => {
                    if (response.status === STATUS_OK) resolve(response.data);
                    else reject(response);
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        reject("cancelled");
                    } else {
                        reject(error);
                    }
                });
        });
    };

    static emailExists = email => {
        lastERequest.cancel();
        let newERequest = CancelToken.source();
        lastERequest = newERequest;
        return new Promise((resolve, reject) => {
            axios
                .get(API_URL + `emails/${encodeURIComponent(email)}`, {
                    cancelToken: newERequest.token
                })
                .then(response => {
                    if (response.status === STATUS_OK) resolve(response.data);
                    else reject(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    };
}
